import getDisplayValue from './getDisplayValue';

const getListDisplayValue = (value, items) => {
  if (Array.isArray(value) && items){
     return value.map((item => getDisplayValue(item, items))).join(', ');
  }
  return "";
};

export default getListDisplayValue;